<template>
  <AppIconButton
    v-if="iconOnly"
    :label="label"
    :disabled="disabled"
    tooltip-placement="left"
    class="app-clear-filters-button"
    @click="$emit('clear')"
  >
    <i class="pi pi-filter-slash" aria-hidden="true" />
  </AppIconButton>
  <AppButton
    v-else
    design="new"
    theme="dark"
    type="button"
    class="app-clear-filters-button"
    :disabled="disabled"
    @click.native="$emit('clear')"
  >
    {{ label }}
  </AppButton>
</template>

<script>
import AppButton from './AppButton'
import AppIconButton from './AppIconButton.vue'

export default {
  name: 'AppClearFiltersButton',
  components: { AppButton, AppIconButton },
  props: {
    design: { type: String, required: true, validator: value => value === 'new' },
    iconOnly: { type: Boolean, default: false },
    label: { type: String, default: 'Clear filters' },
    disabled: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.app-clear-filters-button {
  flex: 0 0 auto;
  justify-self: end;
  max-width: 100%;
  margin-left: auto;
}
</style>
